//* THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
export default {
  af: "Afganistán",
  al: "Albania",
  de: "Alemania",
  ad: "Andorra",
  ao: "Angola",
  ai: "Anguila",
  aq: "Antártida",
  ag: "Antigua y Barbuda",
  sa: "Arabia Saudí",
  dz: "Argelia",
  ar: "Argentina",
  am: "Armenia",
  aw: "Aruba",
  au: "Australia",
  at: "Austria",
  az: "Azerbaiyán",
  bs: "Bahamas",
  bd: "Bangladés",
  bb: "Barbados",
  bh: "Baréin",
  be: "Bélgica",
  bz: "Belice",
  bj: "Benín",
  bm: "Bermudas",
  by: "Bielorrusia",
  bo: "Bolivia",
  ba: "Bosnia y Herzegovina",
  bw: "Botsuana",
  br: "Brasil",
  bn: "Brunéi",
  bg: "Bulgaria",
  bf: "Burkina Faso",
  bi: "Burundi",
  bt: "Bután",
  cv: "Cabo Verde",
  kh: "Camboya",
  cm: "Camerún",
  ca: "Canadá",
  bq: "Caribe neerlandés",
  qa: "Catar",
  td: "Chad",
  cz: "Chequia",
  cl: "Chile",
  cn: "China",
  cy: "Chipre",
  va: "Ciudad del Vaticano",
  co: "Colombia",
  km: "Comoras",
  cg: "Congo",
  kp: "Corea del Norte",
  kr: "Corea del Sur",
  cr: "Costa Rica",
  ci: "Côte d’Ivoire",
  hr: "Croacia",
  cu: "Cuba",
  cw: "Curazao",
  dk: "Dinamarca",
  dm: "Dominica",
  ec: "Ecuador",
  eg: "Egipto",
  sv: "El Salvador",
  ae: "Emiratos Árabes Unidos",
  er: "Eritrea",
  sk: "Eslovaquia",
  si: "Eslovenia",
  es: "España",
  us: "Estados Unidos",
  ee: "Estonia",
  sz: "Esuatini",
  et: "Etiopía",
  ph: "Filipinas",
  fi: "Finlandia",
  fj: "Fiyi",
  fr: "Francia",
  ga: "Gabón",
  gm: "Gambia",
  ge: "Georgia",
  gh: "Ghana",
  gi: "Gibraltar",
  gd: "Granada",
  gr: "Grecia",
  gl: "Groenlandia",
  gp: "Guadalupe",
  gu: "Guam",
  gt: "Guatemala",
  gf: "Guayana Francesa",
  gg: "Guernsey",
  gn: "Guinea",
  gq: "Guinea Ecuatorial",
  gw: "Guinea-Bisáu",
  gy: "Guyana",
  ht: "Haití",
  hn: "Honduras",
  hu: "Hungría",
  in: "India",
  id: "Indonesia",
  iq: "Irak",
  ir: "Irán",
  ie: "Irlanda",
  bv: "Isla Bouvet",
  im: "Isla de Man",
  cx: "Isla de Navidad",
  nf: "Isla Norfolk",
  is: "Islandia",
  ax: "Islas Åland",
  ky: "Islas Caimán",
  cc: "Islas Cocos",
  ck: "Islas Cook",
  fo: "Islas Feroe",
  gs: "Islas Georgia del Sur y Sandwich del Sur",
  hm: "Islas Heard y McDonald",
  fk: "Islas Malvinas",
  mp: "Islas Marianas del Norte",
  mh: "Islas Marshall",
  um: "Islas menores alejadas de EE. UU.",
  pn: "Islas Pitcairn",
  sb: "Islas Salomón",
  tc: "Islas Turcas y Caicos",
  vg: "Islas Vírgenes Británicas",
  vi: "Islas Vírgenes de EE. UU.",
  il: "Israel",
  it: "Italia",
  jm: "Jamaica",
  jp: "Japón",
  je: "Jersey",
  jo: "Jordania",
  kz: "Kazajistán",
  ke: "Kenia",
  kg: "Kirguistán",
  ki: "Kiribati",
  kw: "Kuwait",
  la: "Laos",
  ls: "Lesoto",
  lv: "Letonia",
  lb: "Líbano",
  lr: "Liberia",
  ly: "Libia",
  li: "Liechtenstein",
  lt: "Lituania",
  lu: "Luxemburgo",
  mk: "Macedonia del Norte",
  mg: "Madagascar",
  my: "Malasia",
  mw: "Malaui",
  mv: "Maldivas",
  ml: "Mali",
  mt: "Malta",
  ma: "Marruecos",
  mq: "Martinica",
  mu: "Mauricio",
  mr: "Mauritania",
  yt: "Mayotte",
  mx: "México",
  fm: "Micronesia",
  md: "Moldavia",
  mc: "Mónaco",
  mn: "Mongolia",
  me: "Montenegro",
  ms: "Montserrat",
  mz: "Mozambique",
  mm: "Myanmar (Birmania)",
  na: "Namibia",
  nr: "Nauru",
  np: "Nepal",
  ni: "Nicaragua",
  ne: "Níger",
  ng: "Nigeria",
  nu: "Niue",
  no: "Noruega",
  nc: "Nueva Caledonia",
  nz: "Nueva Zelanda",
  om: "Omán",
  nl: "Países Bajos",
  pk: "Pakistán",
  pw: "Palaos",
  pa: "Panamá",
  pg: "Papúa Nueva Guinea",
  py: "Paraguay",
  pe: "Perú",
  pf: "Polinesia Francesa",
  pl: "Polonia",
  pt: "Portugal",
  pr: "Puerto Rico",
  hk: "RAE de Hong Kong (China)",
  mo: "RAE de Macao (China)",
  gb: "Reino Unido",
  cf: "República Centroafricana",
  cd: "República Democrática del Congo",
  do: "República Dominicana",
  re: "Reunión",
  rw: "Ruanda",
  ro: "Rumanía",
  ru: "Rusia",
  eh: "Sáhara Occidental",
  ws: "Samoa",
  as: "Samoa Americana",
  bl: "San Bartolomé",
  kn: "San Cristóbal y Nieves",
  sm: "San Marino",
  mf: "San Martín",
  pm: "San Pedro y Miquelón",
  vc: "San Vicente y las Granadinas",
  sh: "Santa Elena",
  lc: "Santa Lucía",
  st: "Santo Tomé y Príncipe",
  sn: "Senegal",
  rs: "Serbia",
  sc: "Seychelles",
  sl: "Sierra Leona",
  sg: "Singapur",
  sx: "Sint Maarten",
  sy: "Siria",
  so: "Somalia",
  lk: "Sri Lanka",
  za: "Sudáfrica",
  sd: "Sudán",
  ss: "Sudán del Sur",
  se: "Suecia",
  ch: "Suiza",
  sr: "Surinam",
  sj: "Svalbard y Jan Mayen",
  th: "Tailandia",
  tw: "Taiwán",
  tz: "Tanzania",
  tj: "Tayikistán",
  io: "Territorio Británico del Océano Índico",
  tf: "Territorios Australes Franceses",
  ps: "Territorios Palestinos",
  tl: "Timor-Leste",
  tg: "Togo",
  tk: "Tokelau",
  to: "Tonga",
  tt: "Trinidad y Tobago",
  tn: "Túnez",
  tm: "Turkmenistán",
  tr: "Turquía",
  tv: "Tuvalu",
  ua: "Ucrania",
  ug: "Uganda",
  uy: "Uruguay",
  uz: "Uzbekistán",
  vu: "Vanuatu",
  ve: "Venezuela",
  vn: "Vietnam",
  wf: "Wallis y Futuna",
  ye: "Yemen",
  dj: "Yibuti",
  zm: "Zambia",
  zw: "Zimbabue",
};
